import { useNavigate } from "react-router-dom";
import './PostCard.css';


export default function PostCard({ post }) {
    const navigate = useNavigate();

    const formattedDate = new Date(post.publishedAt).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
});
  return (
    <article
        className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden post-card"
        role="button"
        tabIndex={0}
        onClick={() => navigate(`/post/${post.slug}`)}
        onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                navigate(`/post/${post.slug}`)
            }
        }}
    >
      {post.coverImage && (
        <img
          src={post.coverImage}
          alt={post.title}
          className="card-img-top postcard-img"
        />
      )}

      <div className="card-body d-flex flex-column p-4">
        <span className="small text-muted fw-normal mb-2 d-inline-block">
            {post.category}
        </span>

        <h2 className="h5 fw-bold mb-2 text-dark">
        {post.title}
        </h2>

        <p
        className="text-secondary mb-3"
        style={{ fontSize: '0.95rem', lineHeight: 1.45 }}
        >
        {post.excerpt}
        </p>

        <div className="d-flex justify-content-end mt-auto pt-3">
            <span className="small text-muted">{formattedDate}</span>
        </div>



      </div>
    </article>
  );
}